import React from "react";

export default function HarmoniqIcon({ className, size = 45, color = "#7D38DF", ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 45 45"
      fill="none"
      className={className}
      aria-hidden="true"
      {...rest}
    >
      <path
        fill={color}
        d="M25.712 45.004h-6.429V32.146h6.429zm-12.852-6.43H6.43v-6.428h6.43zm25.71 0h-6.428v-6.428h6.428zM25.712 12.857h6.437v6.432H45v6.429h-12.85v6.427H12.862V12.857h6.421V0h6.429zm-12.854 12.86H0V19.29h12.858zm.002-12.86H6.43v-6.43h6.43zm25.71 0h-6.428v-6.43h6.428z"
      />
    </svg>
  );
}
